import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "totalRow"
}
const _hoisted_2 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_ReportExporter = _resolveComponent("ReportExporter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_data_table, {
      headers: _ctx.reportHeaders,
      items: _ctx.reportData,
      density: "compact",
      class: "elevation-1",
      "no-data-text": "No results found"
    }, _createSlots({
      "item.total": _withCtx(({ item }) => [
        _createElementVNode("b", null, _toDisplayString(item.total), 1)
      ]),
      "body.append": _withCtx(() => [
        (_ctx.reportData.length > 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
              _createElementVNode("th", {
                colspan: _ctx.headers.length
              }, "Totals", 8, _hoisted_2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fiscalHeaders, (field, index) => {
                return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(_ctx.totalRow[field.key]), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.reportData.length <= 10)
        ? {
            name: "bottom",
            fn: _withCtx(() => []),
            key: "0"
          }
        : undefined
    ]), 1032, ["headers", "items"]),
    (!_ctx.isSearching && _ctx.reportData.length > 0)
      ? (_openBlock(), _createBlock(_component_ReportExporter, {
          key: 0,
          items: _ctx.dataWithTotals,
          title: _ctx.title,
          filename: _ctx.filename,
          headers: _ctx.reportHeaders
        }, null, 8, ["items", "title", "filename", "headers"]))
      : _createCommentVNode("", true)
  ], 64))
}